// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"projects_bridges_src_app_app_module_ts":"376593042836ce28","projects_bridges_src_app_features_admin_admin_module_ts":"980856279c32ccea","projects_bridges_src_app_features_microsoft-teams_teams_component_ts":"0f6c58f4e6a42014"}[chunkId] + ".js";
};